module.exports = __webpack_public_path__ + "media/ring.fcda9709.mp3";